import { render } from "./ModelResultsModal.vue?vue&type=template&id=b2fcb0f0&scoped=true"
import script from "./ModelResultsModal.vue?vue&type=script&lang=js"
export * from "./ModelResultsModal.vue?vue&type=script&lang=js"

import "./ModelResultsModal.vue?vue&type=style&index=0&id=b2fcb0f0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2fcb0f0"]])

export default __exports__